import { Loader, LoaderSizes } from "@hid-galaxy-ui/galaxy-react";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { getAuthToken, getUserInfo, setAuthToken, setUserInfo } from "../utils";
import { API_BASE_URL_SSO, TENANT_ID } from "../utils/common";
import { LoginPath } from "../routes";

const SsoCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [searchParams] = useSearchParams();
  useEffect(() => {
    // 1. Read query params
    const code = searchParams.get("code");
    // 2. Call backend API to exchange code for token
    const fetchToken = async () => {
      try {
        const callbackUrl = `${API_BASE_URL_SSO}/auth/callback?tenant_id=${TENANT_ID}&code=${code}`;
        const response = await fetch(callbackUrl, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        // 3. Store token in localStorage
        if (data.access_token) {
          setAuthToken(data.access_token);
          // 2. Fetch user info
          const userInfoUrl = `${API_BASE_URL_SSO}/auth/sso-user-info?tenant_id=${TENANT_ID}&access_token=${data.access_token}`;
          const userInfoRes = await fetch(userInfoUrl, {
            method: "GET",
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${getAuthToken()}`,
            },
          });
          const userInfo = await userInfoRes.json();
          setUserInfo(JSON.stringify(userInfo));
          navigate("/chat");
        } else {
          // handle error
          setError(true);
        }
      } catch (err) {
        setError(true);
      }
    };

    if (code) fetchToken();
    else setError(true);
  }, [navigate]);

  if (error) {
    return <Navigate to={LoginPath}></Navigate>;
  }
  return <Loader variant={LoaderSizes.medium} isOverlay />;
};

export default SsoCallback;
